/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_4_TitleInputs */

const en_mk_cap_4_title = /** @type {(inputs: Mk_Cap_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search and ⌘K`)
};

const id_mk_cap_4_title = /** @type {(inputs: Mk_Cap_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencarian dan ⌘K`)
};

/**
* | output |
* | --- |
* | "Search and ⌘K" |
*
* @param {Mk_Cap_4_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_4_title = /** @type {((inputs?: Mk_Cap_4_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_4_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_4_title(inputs)
	return en_mk_cap_4_title(inputs)
});